import { render, staticRenderFns } from "./BonusesInModalNew.vue?vue&type=template&id=264ad528&scoped=true&"
import script from "./BonusesInModalNew.vue?vue&type=script&lang=js&"
export * from "./BonusesInModalNew.vue?vue&type=script&lang=js&"
import style0 from "./BonusesInModalNew.vue?vue&type=style&index=0&id=264ad528&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264ad528",
  null
  
)

export default component.exports